import { render, staticRenderFns } from "./HeaderAvatar.vue?vue&type=template&id=143643d9"
import script from "./HeaderAvatar.vue?vue&type=script&lang=js"
export * from "./HeaderAvatar.vue?vue&type=script&lang=js"
import style0 from "./HeaderAvatar.vue?vue&type=style&index=0&id=143643d9&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\workspace\\ysorder\\order_admin_client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('143643d9')) {
      api.createRecord('143643d9', component.options)
    } else {
      api.reload('143643d9', component.options)
    }
    module.hot.accept("./HeaderAvatar.vue?vue&type=template&id=143643d9", function () {
      api.rerender('143643d9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/header/HeaderAvatar.vue"
export default component.exports